<img [src]="iconPath()" class="group-classes-icon" />